import React from 'react'
import { useState } from 'react';


function FaqItem(props) {
    const { id,question, answer } = props.item;
    const [isOpen, setisOpen] = useState(false);
    const toggleItem = () => {
        setisOpen(!isOpen);
    };
    return (
        <div className="border rounded my-2">
    <button
        //className="w-100 py-3 px-4 d-flex justify-content-between align-items-center bg-light border-0"
        className="w-100 py-3 px-4 bg-light border-0 "
        onClick={toggleItem}
    >
        <div className="d-flex justify-content-between align-items-center text-start">
        <span className="h5 mb-0 fw-medium text-dark">{question}</span>
        {isOpen ? (
            <span className="fs-4 text-secondary">-</span>
        ) : (
            <span className="fs-4 text-secondary">+</span>
        )}
        </div>
    </button>
    {isOpen && (
        <div className="my-2 px-4 pb-3 bg-white">
            <p className="text-muted mb-0">{answer}</p>
        </div>
    )}
</div>
    )
}

export default FaqItem